'use strict';
const AncillariesTracking = require('./ancillaries_base');

const EVENT_ACTION = 'confirm_purchase';
const PAYMENT_DETAILS_ACTION = 'payment_details';

const POLICY = AncillariesTracking.POLICY;
const PRICE_WITHOUT_INSURANCE = AncillariesTracking.PRICE_WITHOUT_INSURANCE;
const PRICE_WITH_INSURANCE = AncillariesTracking.PRICE_WITH_INSURANCE;

const TRACKING_PAGES = {
    mobile: {
        payment: 'payment',
    },
};

const EVENTS_DICTIONARY = {
    'continue_with_insurance': {
        'action': EVENT_ACTION,
        'label': `purchase_${POLICY}_PN:${PRICE_WITHOUT_INSURANCE}_PI:${PRICE_WITH_INSURANCE}`,
    },
    'continue': {
        'action': EVENT_ACTION,
        'label': `purchase_${POLICY}_PN:${PRICE_WITHOUT_INSURANCE}_PI:NA`,
    },
    'submit_error': {
        'action': EVENT_ACTION,
        'label': `purchase_${POLICY}_FE_error`,
    },
    'open_details': {
        'action': EVENT_ACTION,
        'label': `open_price_breakdown`,
    },
    'close_details': {
        'action': EVENT_ACTION,
        'label': `close_price_breakdown`,
    },
    'open_coverage': {
        'action': EVENT_ACTION,
        'label': `open_coverage_${POLICY}`,
    },
    'terms_and_conditions_open': {
        'action': PAYMENT_DETAILS_ACTION,
        'label': `link_data_${POLICY}_policy_open`,
    },
    'terms_and_conditions_close': {
        'action': PAYMENT_DETAILS_ACTION,
        'label': `link_data_${POLICY}_policy_close`,
    },
    'what_is_open': {
        'action': PAYMENT_DETAILS_ACTION,
        'label': `what_is_${POLICY}_policy_open`,
    },
    'what_is_close': {
        'action': PAYMENT_DETAILS_ACTION,
        'label': `what_is_${POLICY}_policy_close`,
    },
    'on_load': {
        'action': EVENT_ACTION,
        'label': `purchase-onload_product:${POLICY}_pag:pay`,
    },
};

class AncillariesTrackingGuarantees extends AncillariesTracking {
    constructor(product, variables) {
        super(
            product,
            EVENTS_DICTIONARY,
            null,
            null,
            TRACKING_PAGES,
            variables
        );
    }
}

AncillariesTrackingGuarantees.prototype.submitError = AncillariesTrackingGuarantees.prototype.prepareTrackEventFunction('submit_error');
AncillariesTrackingGuarantees.prototype.continueWithInsurance =
    AncillariesTrackingGuarantees.prototype.prepareTrackEventFunction('continue_with_insurance');
AncillariesTrackingGuarantees.prototype.termsAndConditionsOpen =
    AncillariesTrackingGuarantees.prototype.prepareTrackEventFunction('terms_and_conditions_open');
AncillariesTrackingGuarantees.prototype.termsAndConditionsClose =
    AncillariesTrackingGuarantees.prototype.prepareTrackEventFunction('terms_and_conditions_close');
AncillariesTrackingGuarantees.prototype.openCoverage = AncillariesTrackingGuarantees.prototype.prepareTrackEventFunction('open_coverage');
AncillariesTrackingGuarantees.prototype.whatIsOpen = AncillariesTrackingGuarantees.prototype.prepareTrackEventFunction('what_is_open');
AncillariesTrackingGuarantees.prototype.whatIsClose = AncillariesTrackingGuarantees.prototype.prepareTrackEventFunction('what_is_close');
AncillariesTrackingGuarantees.prototype.onLoad = AncillariesTrackingGuarantees.prototype.prepareTrackEventFunction('on_load');

module.exports = AncillariesTrackingGuarantees;
